import _ from 'lodash';

import { Form } from './form';
import { Attribute } from '../attributes/attribute';
import { FormAttributeDefinition } from './formAttributeDefinition';
import { FormPage } from './formPage';
import { AttributeDefinition } from 'src/app/shared/models/attributes/attributeDefinition';
import { PositionPickerModel } from './positionPickerModel';

export class Application {
  form: Form;
  email: string;
  questions: FormAttributeDefinition[];
  positions: PositionPickerModel[];
  pages: FormPage[];
  publicTeamName: string;
  teamName: string;

  get hasExpired(): boolean {
    if (!this.form) return false;
    return this.form.hasExpired;
  }

  public filterForShowCurrentValues(values: Array<Attribute>): Array<Attribute> {
    let filtered = _.filter(values, (attribute) => {
      let attributeDefinition = _.find(
        this.questions,
        (attributeDefinition) => attributeDefinition.id == attribute.attributeDefinitionId
      );

      let hiddenSubField =
        attributeDefinition?.uiType == 'Complex' &&
        attributeDefinition.subFieldList.find(
          (sf) => sf.id == attribute.complexAttributeSubFieldValue.subFieldDefinitionItemId
        )?.isHiddenOnForms;

      return attributeDefinition
        ? (attributeDefinition.showCurrentValue && !hiddenSubField) || attribute.edited
        : false;
    });
    return filtered;
  }

  static parse(data: Partial<Application>): Application {
    if (!data) return;

    var application = new Application();
    application.email = data.email;
    application.form = Form.parse(data.form);
    application.questions = data.questions?.length
      ? data.questions.map((q) => FormAttributeDefinition.parse(q))
      : [];
    application.pages = data.pages;
    application.teamName = data.teamName;
    application.publicTeamName = data.publicTeamName;
    //AttributeDefinition instances (not plain objects) — EditableAttribute and getIcon() need the class
    application.positions = (data.positions ?? []).map((position) => ({
      ...position,
      seatFields: (position.seatFields ?? []).map((field) => AttributeDefinition.parse(field))
    }));
    return application;
  }
}
